import { styled } from "@mui/material";

export const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  width: "100%",
  height: "100vh",
  background: `linear-gradient(to right, ${theme.palette.primary.errorGradient1}, ${theme.palette.primary.errorGradient2})`,
  "& a": {
    textDecoration: "none",
  },
}));

export const TextContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  borderTop: `1px solid ${theme.palette.primary.grey}`,
  borderBottom: `1px solid ${theme.palette.primary.grey}`,
  margin: "0 auto",
  padding: 20,
  width: "50%",
  [theme.breakpoints.down("md")]: {
    border: "none",
    width: "80%",
  },
}));

export const ErrorImage = styled("img")(({ theme }) => ({
  width: 500,
  [theme.breakpoints.down("md")]: {
    width: 400,
  },
}));
